export const WIDGET_ID = "widget-trending-keywords";
